import React from "react";
import "../styles.css";

const HowItWorks: React.FC = () => {
  return (
    <section id="how" className="container how">
      <h2>How it works</h2>
      <div className="how-grid">
        <div className="how-card">
          <div className="how-icon">📋</div>
          <h3>1. Paste a JD</h3>
          <p>Drop in any job description from any site. We parse the signal from the fluff.</p>
        </div>
        <div className="how-card">
          <div className="how-icon">⬆️</div>
          <h3>2. Add your résumé</h3>
          <p>Copy-n-Paste your resume to unlock a personalized fit score and guidance.</p>
        </div>
        <div className="how-card">
          <div className="how-icon">🎯</div>
          <h3>3. Get your fit score</h3>
          <p>See strengths, gaps, and BS flags—plus clear steps to improve your odds.</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
